<template>
  <el-dialog
    class="dialog"
    title="资源配置"
    width="1100px"
    :visible.sync="showResourceManage.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <div class="main-contant">
      <Search class="search_right" ref="search" @search="searchHandle" />
      <!--表格内容栏-->
      <el-table
          ref="pageListTable"
          border
          :data="tableInfo.data"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400,}"
          :header-cell-style="{
            background: '#DCE7FA',
            color: '#343C4A',
            fontWeight: 500,
          }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :selectable="selectInit"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="资源名称"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="ellipsis--l2">{{scope.row.name || scope.row.lecturerName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="bizTypeName"
            label="类型"
            width="120"
            v-if="bizType !== 17"
          >
          </el-table-column>
          <el-table-column
            prop="onlineDate"
            label="上线时间"
            width="180"
            show-overflow-tooltip
            v-if="bizType !== 17"
          ></el-table-column>
      </el-table>
      <!--分页栏-->
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="tableInfo.currentPage"
          :page-size="tableInfo.size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableInfo.total"
          background
          hide-on-single-page
        />
      <!-- <Table ref="pageListTable" :info="tableInfo" @HandleSelectionChanges="handleSelectionChanges" @SizeChange="sizeChange" @PageChange="pageChange"/> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from "./search.vue";
import { getLecturerParamList } from "@/api/lecturer";
import {
  findResourcesList,
  findRelationResourcesList,
  configInfoSave,
} from "@/api/configInfo";

export default {
  components: {
    Search,
  },
  props: {
    bizType: {
      type: Number,
      default: () => 0,
    },
    showResourceManage: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      tableInfo: {},
    };
  },
  created() {
    this.initTableInfo();
    // 初始化表格数据->先获取已选中资源->调用资源列表接口
    this.getSelectResource();
  },
  methods: {
    selectInit(row) {
      return !row.disabled;
    },
    // 初始化：多类型资源表格数据
    initTableInfo() {
      this.tableInfo = {
        originCheckList: [],
        data: [],
        total: 0,
        currentPage: 1,
        size: 10,
        currentCheckList: [],
      }
    },
    cancel() {
      this.$emit("closeConfig");
    },
    handleSelectionChanges(rows) {
      this.tableInfo.currentCheckList = rows;
    },
    pageChange(page) {
      this.tableInfo.currentPage = page;
      this.getResources(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.tableInfo.size = size;
      this.getResources(this.$refs.search.filters);
    },
    // 已添加资源
    getSelectResource() {
      findRelationResourcesList(this.bizType).then((res) => {
        if (res.code !== 0) return;
        this.tableInfo.originCheckList = res.data.map((ele) => ele.uuid);
        // 获取列表数据
        this.getResources();
      })
    },
    // 历史选中回显置灰
    getResources(query={}) {
      let { keyWord } = query;
      //根据资源类型查询资源列表
      let params = {
        page: this.tableInfo.currentPage,
        limit: this.tableInfo.size,
        bizType: this.bizType,
        keyWord: keyWord || ""
      };
      if (this.bizType == 17) {
        params = {
          page: this.tableInfo.currentPage,
          limit: this.tableInfo.size,
          lecturerName: keyWord || "",
        };
        getLecturerParamList(params).then((resp) => {
          if (resp.code !== 0) return;
          this.handleRespData(resp);
        });
      } else {
        findResourcesList(params).then((resp) => {
          if (resp.code !== 0) return;
          this.handleRespData(resp);
        });
      }
    },
    // 处理接口返回数据
    handleRespData(resp) {
      // 资源分类 表格赋值
      this.tableInfo.data = resp.data.records;
      this.tableInfo.total = resp.data.total;
      this.tableInfo.currentPage = resp.data.current;
      if (this.tableInfo.data.length >  0) {
        const _this = this;
        _this.tableInfo.data.map((v) => {
          _this.tableInfo.originCheckList.map((i) => {
            if (v.uuid == i) {
              v.disabled = true;
              this.$refs.pageListTable.toggleRowSelection(v);
            }
          });
        });
      }
    },
    // 条件筛选
    searchHandle(data) {
      // 记住查询条件
      this.tableInfo.currentPage = 1;
      this.getResources(data);
    },
    confirm() {
      // 过滤出新选中数据
      let newCheckList = this.tableInfo.currentCheckList.filter(item => !this.tableInfo.originCheckList.includes(item.uuid));
      let params = {
        bizType: this.bizType,
        resourcesVos: newCheckList,
      };
      if (newCheckList.length < 1) {
        this.$message({
          message: "请选择至少一条资源",
          type: "warning",
        });
        return;
      }
      configInfoSave(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.$emit("addSucceed");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$text-color: #51627d;
$text-font: 14px;

/deep/ .el-pagination {
  text-align: right !important;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    padding: 20px;
    .search_content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .mlButn{
      margin-left: 10px;
    }
  }
  .pagination {
    margin-top: 14px;
  }
}
</style>
